"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const Checkbox_1 = tslib_1.__importDefault(require("../checkbox/Checkbox"));
const TreeSelectAll = props => {
    const { isDisabled, isChecked, isEnabled, isIndeterminate, onSelect } = props;
    const handleSelectAll = event => onSelect(event.target.checked, isIndeterminate);
    return isEnabled ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'TreeSelectAll display-flex align-items-center' }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: isChecked, onClick: handleSelectAll, disabled: isDisabled, indeterminate: isIndeterminate, className: 'margin-top--1' }) }))) : null;
};
TreeSelectAll.displayName = 'TreeSelectAll';
TreeSelectAll.defaultProps = {
    isChecked: false,
    isEnabled: true,
    isIndeterminate: false,
    hasSearchResults: false,
    onChange: () => { },
};
TreeSelectAll.propTypes = {
    value: prop_types_1.default.string,
    onSelect: prop_types_1.default.func,
    isChecked: prop_types_1.default.bool,
    isEnabled: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    isIndeterminate: prop_types_1.default.bool,
    hasSearchResults: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.default = TreeSelectAll;
